module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.a9dc1806.svg";